export default function DownArrow(props) {
  return (
    <svg
      width={props.width || "12"}
      height={props.height || "8"}
      viewBox="0 0 12 8"
      fill={props.fill || "#FFFFFF"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11 1.17001C10.8126 0.983756 10.5592 0.879215 10.295 0.879215C10.0308 0.879215 9.77737 0.983756 9.59 1.17001L6 4.71001L2.46 1.17001C2.36821 1.07132 2.25741 0.9922 2.13426 0.937413C2.01111 0.882627 1.87816 0.8533 1.7434 0.851196C1.60863 0.849092 1.47483 0.874253 1.35003 0.925168C1.22523 0.976084 1.11202 1.0517 1.01718 1.14748C0.922349 1.24326 0.847856 1.35722 0.79818 1.48251C0.748504 1.60781 0.724669 1.74185 0.728109 1.87659C0.731548 2.01133 0.76219 2.14399 0.818194 2.26658C0.874198 2.38918 0.954408 2.49919 1.054 2.59001L5.294 6.83001C5.38697 6.92374 5.49757 6.99813 5.61943 7.0489C5.74129 7.09967 5.87199 7.12581 6.004 7.12581C6.13602 7.12581 6.26672 7.09967 6.38858 7.0489C6.51044 6.99813 6.62104 6.92374 6.714 6.83001L11.004 2.59001C11.0977 2.49704 11.1721 2.38644 11.2229 2.26458C11.2737 2.14272 11.2998 2.01202 11.2998 1.88001C11.2998 1.748 11.2737 1.61729 11.2229 1.49543C11.1721 1.37357 11.0977 1.26297 11.004 1.17001H11Z" />
    </svg>
  )
}
